(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-ribbon"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('text-ribbon')) {
    class TextRibbon extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.text-ribbon__viewport');
        this.track = this.querySelector('.text-ribbon__track');
        this.group = this.querySelector('.text-ribbon__group');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.onMotion = () => this.layout(true);
        this.motion.addEventListener('change', this.onMotion);

        this.resizeObserver = new ResizeObserver(() => this.layout());
        this.resizeObserver.observe(this.viewport);
        this.layout(true);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.motion?.removeEventListener('change', this.onMotion);
      }

      reset() {
        this.track.querySelectorAll('[data-clone]').forEach((el) => el.remove());
        this.classList.remove('is-animated');
      }

      layout(force = false) {
        const width = this.viewport.clientWidth;
        if (!force && width === this.lastWidth) return;
        this.lastWidth = width;
        this.reset();

        const mode = this.dataset.motion || 'auto';
        if (mode === 'off' || this.motion.matches) return;

        // Measure one group laid out on a single line.
        this.classList.add('is-animated');
        const groupWidth = this.group.getBoundingClientRect().width;
        if (!groupWidth) return;

        // Auto: only scroll when the messages don't fit side by side.
        // groupWidth includes one trailing gap; the static layout adds 16px each side.
        const gap = parseFloat(getComputedStyle(this.group).columnGap) || 0;
        if (mode === 'auto' && groupWidth - gap + 32 <= width) {
          this.reset();
          return;
        }

        // Enough copies that the track always covers the viewport while
        // shifting left by exactly one group width. Clones stay clickable
        // (whatever copy is on screen must work) but are hidden from
        // assistive tech and removed from the tab order.
        const copies = Math.ceil(width / groupWidth) + 1;
        for (let i = 1; i < copies; i += 1) {
          const clone = this.group.cloneNode(true);
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => {
            el.removeAttribute('data-shopify-editor-block');
          });
          this.track.append(clone);
        }

        const pxPerSecond = Number(this.dataset.speed) || 60;
        this.style.setProperty('--ribbon-shift', `${-groupWidth}px`);
        this.style.setProperty('--ribbon-duration', `${groupWidth / pxPerSecond}s`);
      }
    }

    customElements.define('text-ribbon', TextRibbon);
  }

  } catch(e) { console.error(e); }
})();
})();
